// removed by extract-text-webpack-plugin
module.exports = {"root":"WRpY-","feature":"_3NrRc"};